import React, { Component } from 'react'
import { Button, Col, Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { IconeSetaSubir, IconeSetaDescer } from '../../../../comum/components/Icones'
import { observer } from 'mobx-react';
import CardDetalheServico from './CardDetalheServico'
import Tooltip from '../../../../comum/components/Tooltip'
import Checkbox from '../../../../comum/components/Checkbox'
import LoadingImage from './../../../../comum/components/LoadingImage';

@observer
export default class ResultadoPesquisa extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    render() {

        if(this.controller.listaDetalhesServico === null) {
            return null;
        } else {

            const selectRow = {
                mode: 'checkbox',
                selected: this.controller.listaDetalhesServicoSelecionados.map(service => service.CdTipoServico),
                selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                    <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                        <Checkbox ativo={rest.checked} onClick={() => { }} />
                    </Tooltip>
                ),
                selectionRenderer: ({ mode, ...rest }) =>
                    <Checkbox ativo={rest.checked} onClick={() => { }} />,
                    onSelect: (row, isSelect, rowIndex, e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.controller.selecionarDetalhesServico(row);
                    },
                    onSelectAll: (isSelect, rows, e) => {
                        e.preventDefault();
                        e.stopPropagation();
        
                        this.controller.selecionarTodosDetalhesServico(rows, isSelect);
    
                        if (isSelect) {
                            const selecao = this.controller.listaDetalhesServico.map(item => item.CdTipoServico);
                            return selecao;
                        } else {
                            return [];
                        }
                    }
    
            }

            return (
                <div className="card-expansivel card-expansivel-tabela tabela-acomp-processo">
                    <div style={{overflowX:"hidden"}} className="card p-0 m-0">
                        <Row className={`titulo-booking align-items-center p-0 ${this.controller.resultadoPesquisaExpandir && 'login-form'}`}>
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <h4 className="mt-2 ml-2">Detalhes do serviço</h4>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <div className="float-right mt-2 mr-4">
                                    <Button  onClick={ this.controller.toggleResultadoPesquisa } outline className="collapseItem collapseItem-small" active={false}>
                                    { this.controller.resultadoPesquisaExpandir ? <IconeSetaSubir /> : <IconeSetaDescer /> }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        {
                            this.controller.resultadoPesquisaExpandir &&
                            <div style={{backgroundColor:"white", margin:"0px", padding:"0px"}}>
                                {
                                    window.innerWidth > 550
                                    ?
                                    <div className="mt-2">
                                        <ToolkitProvider
                                            
                                            keyField="CdTipoServico"
                                            data={[...this.controller.listaDetalhesServico]}
                                            columns={this.controller.colunasDetalhesServico}
                                        >
                                            {props => <div style={{maxHeight:'30vh'}}>
                                                <div style={{maxHeight:'29vh', overflow:'auto'}}>
                                                    <BootstrapTable bootstrap4
                                                        striped
                                                        bordered={false}
                                                        classes="tabela tabela-layout"
                                                        selectRow={ selectRow }
                                                        {...props.baseProps}
                                                    />    
                                                </div>
                                            </div>}
                                        </ToolkitProvider>
                                    </div>
                                    :<div style={{maxHeight:'30vh'}}>
                                        <div style={{maxHeight:'29vh',overflow:'auto'}}>
                                            {
                                            this.controller.listaDetalhesServico.map(detalhe => (
                                                <CardDetalheServico
                                                    key={detalhe.CdTipoServico}
                                                    controller={this.controller}
                                                    data={detalhe}
                                                    selecionar={this.controller.selecionarDetalhesServico}
                                                    id={detalhe.CdTipoServico}
                                                    colunas={[...this.controller.colunasDetalhesServico]}
                                                />
                                                ))
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>                     
                    {(this.controller.tabelaDados && this.controller.tabelaDados.length > 0) && 
                    <Button className="btn-com-bordas-primary float-right mr-0"
                            onClick={this.controller.gerarDemonstrativo}>
                        Gerar Demonstrativo
                    </Button>}
                    <Button className="btn-com-bordas-primary float-right mr-0" onClick={this.controller.abrirModalCalculo}>Calcular</Button>                   
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/ResultadoPesquisa.js